module.exports = __webpack_public_path__ + "static/img/B (15).30046568.png";